import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { Warning } from '@mui/icons-material';
import Cookies from 'js-cookie';

const TrialWarningBanner = () => {
  const trialStatusStr = Cookies.get('trialStatus');
  if (!trialStatusStr) return null;

  let trialStatus;
  try {
    trialStatus = JSON.parse(trialStatusStr);
  } catch (e) {
    console.error('Failed to parse trial status:', e);
    return null;
  }
  
  if (!trialStatus.show_warning || !trialStatus.is_on_trial || trialStatus.is_paid) {
    return null;
  }

  return (
    <Alert 
      severity="warning" 
      icon={<Warning />}
      sx={{ 
        borderRadius: 0,
        mb: 0,
        backgroundColor: '#fff3cd',
        borderBottom: '2px solid #ffc107',
        '& .MuiAlert-message': { width: '100%' }
      }}
    >
      <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>
        Trial Period Ending Soon
      </AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Your trial period is almost done and will be stopped. Please contact support.
      </Typography>
      {trialStatus.days_remaining !== null && trialStatus.days_remaining !== undefined && (
        <Box sx={{ mt: 1, fontSize: '0.9rem', fontWeight: 500 }}>
          <strong>{trialStatus.days_remaining} days remaining</strong>
        </Box>
      )}
    </Alert>
  );
};

export default TrialWarningBanner;

